/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-12 03:02:07
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagRuleUnion,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    UITag,
} from "./core";
import { lang } from "@root/core/i18n";

// @uiValidator - add validate rule to form element.
// allow value: Function, Object (state / message pair), false (cancel the validation pipeline)

@UITag.set()
export class uiValidator extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.FormElement];
    ruleTypes: EUITagRuleUnion[] = [
        EUITagRuleType.Function,
        EUITagRuleType.Object,
        EUITagRuleType.Boolean,
    ];
    allowNullRule: boolean = false;

    /// set props :description
    parse(input: IUITagInput): IUITagResult | null {
        const rule = this.parseRule(input);
        if (rule == null) return null;

        /// normal case
        // if false, cancel the validator pipeline
        return {
            props: { validator: rule == false ? null : validatorWrapper(input, rule) },
        };
    }
}

function validatorWrapper(input: IUITagInput, rule: Object | Function) {
    const validator: Function | undefined = (input.inputs.props as any).validator;
    const func = (o) => {
        const rtn = typeof rule === "object" ? rule : rule(o);
        if (rtn?.message != null) {
            /// do post-translation
            const key = rtn.message;
            rtn.message = lang.keyExists(key) ? lang.translate(key) : key;
        }
        return rtn;
    };

    /// follow the main rule: if null, return null. if undefined, pass into next function.
    if (validator == undefined) return func;
    return (o) => {
        const result = validator(o);
        if (result != null) return result;
        else if (result === null) return null;
        /// undefined case
        return func(o);
    };
}
